export const IDLE_ROUND_LIMIT = 3;

export function tableRoundKey(table) {
  return String(table?.LastSetID ?? table?.SetsModel?.SetsID ?? table?.JuId ?? '').trim();
}

// Count completed, distinct rounds at the watched table, not timers or renders.
// Switching tables carries the consecutive idle count; leaving the game resets it.
export class IdleRoundTracker {
  constructor() {
    this.leave();
  }

  leave() {
    this.tableIndex = null;
    this.roundKey = '';
    this.idleRounds = 0;
    this.betAccepted = false;
    this.seenRounds = new Set();
  }

  enter(tableIndex, roundKey, betAccepted = false) {
    if (this.tableIndex === null) this.idleRounds = 0;
    this.tableIndex = tableIndex;
    this.roundKey = String(roundKey ?? '').trim();
    this.betAccepted = Boolean(betAccepted);
    this.seenRounds = new Set(this.roundKey ? [this.roundKey] : []);
  }

  acceptBet(tableIndex, roundKey) {
    if (!this.roundKey || tableIndex !== this.tableIndex || String(roundKey ?? '').trim() !== this.roundKey) return false;
    this.betAccepted = true;
    this.idleRounds = 0;
    return true;
  }

  nextRound(tableIndex, roundKey) {
    const key = String(roundKey ?? '').trim();
    if (tableIndex !== this.tableIndex || !key || this.seenRounds.has(key)) return null;
    // Replayed/stale numeric SetIDs must not count as another completed round.
    if (/^\d+$/.test(key) && /^\d+$/.test(this.roundKey) && BigInt(key) <= BigInt(this.roundKey)) return null;
    const previousRoundKey = this.roundKey;
    this.roundKey = key;
    this.seenRounds.add(key);
    if (this.seenRounds.size > 16) this.seenRounds.delete(this.seenRounds.values().next().value);
    if (!previousRoundKey) {
      this.betAccepted = false;
      return null;
    }
    this.idleRounds = this.betAccepted ? 0 : this.idleRounds + 1;
    this.betAccepted = false;
    const event = { tableIndex, previousRoundKey, roundKey: key, idleRounds: this.idleRounds, shouldReturn: this.idleRounds >= IDLE_ROUND_LIMIT };
    if (event.shouldReturn) this.leave();
    return event;
  }
}
